import ChartDoughnut from "./ChartDoughnut";
import React, {useEffect, useState} from "react";
import neverLandUtils from "../../utils/NeverLandUtils";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_OPPONENT_RECORD_DATA_API} from "../../constants/api_constants";
import {ModalHandler} from "../Modal/Generic/ModalHandler";
import {getImage} from "../../constants/constants";
import dayjs from "dayjs";

// const buttonData = [
//   {name: "전체", value: 1},
//   {name: "홈/원정", value: 2},
// ]


const OpponentRecordeComponent = ({dataId, analysisType}) => {
  const chartDataList = [
    [{data: [0, 0, 0], backgroundColor: ["#e82049", "#f88f17", "#314bca"]},],
  ];

  const [dataList, setDataList] = useState(chartDataList);
  // const [showOptionButton, setShowOptionButton] = useState(false);
  // const [optionButtonValue, setOptionButtonValue] = useState(buttonData[0].value);
  const [recordData, setRecordData] = useState([]);
  const [homeTeamName, setHomeTeamName] = useState(null);
  const [awayTeamName, setAwayTeamName] = useState(null);

  const [homeRecordStats, setHomeRecordStats] = useState({win: 0, draw: 0, lose: 0, count: 0});
  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);


  useEffect(() => {
    getOpponentRecordeData();
  }, []);

  useEffect(() => {
    if (recordData.length === 0) return;
    updateOpponentRecordChartView(recordData);
  }, [recordData]);

  function updateOpponentRecordChartView(recordData) {
    let graphData = [...chartDataList];

    let this_record_data = _normalizeRecordDataForTeamName(recordData, homeTeamName, awayTeamName);
    const homeStats = setRecodeDataToGraph(graphData, this_record_data, homeTeamName, 0);

    setDataList(graphData);

    setHomeRecordStats(homeStats);
  }

  function _changeTeamName(recordData, originTeamName, newTeamName) {
    const updatedData = [...recordData];

    for (const record of updatedData) {
      if (record.homeTeam === originTeamName) {
        record.homeTeam = newTeamName;
      }
      if (record.awayTeam === originTeamName) {
        record.awayTeam = newTeamName;
      }
    }
    return updatedData;
  }

  function _normalizeRecordDataForTeamName(recordData, homeTeamName, awayTeamName) {
    // 데이터와 팀이름이 안맞는게 있을 경우 팀이름 대체하기
    // 둘다 안맞는 경우에는 답없음, 하나라도 맞다는게 있다는 전제하에 작성한거임
    if (recordData.length === 0) return recordData;

    const {homeTeam, awayTeam} = recordData[0];

    if (homeTeam === homeTeamName && awayTeam !== awayTeamName) {
      return _changeTeamName(recordData, awayTeam, awayTeamName);
    }
    if (awayTeam === homeTeamName && homeTeam !== awayTeamName) {
      return _changeTeamName(recordData, homeTeam, awayTeamName);
    }
    if (homeTeam === awayTeamName && awayTeam !== homeTeamName) {
      return _changeTeamName(recordData, awayTeam, homeTeamName);
    }
    if (awayTeam === awayTeamName && homeTeam !== homeTeamName) {
      return _changeTeamName(recordData, homeTeam, homeTeamName);
    }
    return recordData;
  }

  function setRecodeDataToGraph(graphData, recordData, teamName, dataIndex) {
    // 데이터에서 총 경기수 / 승 / 무 / 패 각각 카운트
    let win = 0;
    let draw = 0;
    let lose = 0;
    let count = 0;

    for (let recordItem of recordData) {
      if (recordItem.homeTeam === teamName || recordItem.awayTeam === teamName) {
        count++;
        if (recordItem.homeScore === recordItem.awayScore) {
          draw++;
        } else if (
            (recordItem.homeTeam === teamName && recordItem.homeScore > recordItem.awayScore) ||
            (recordItem.awayTeam === teamName && recordItem.awayScore > recordItem.homeScore)
        ) {
          win++;
        } else {
          lose++;
        }
      }
    }
    if (count > 0) {
      graphData[dataIndex][0].data[0] = Math.floor((win * 100) / count);  // 승
      graphData[dataIndex][0].data[1] = Math.floor((draw * 100) / count); // 무
      graphData[dataIndex][0].data[2] = Math.floor((lose * 100) / count); // 패
    } else {
      graphData[dataIndex][0].data = [0, 0, 0];
    }
    return {win, draw, lose, count};
  }

  const getOpponentRecordeData = () => {
    // 최근 전적
    getFetcherAnalysis().get(GET_OPPONENT_RECORD_DATA_API + `?dataId=${dataId}&analysisType=${analysisType}`) // recordType : 전적 타잎 (1: 최근전적, 2: 상대전적)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            if (data[0].recordData.length === 0) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            const _homeTableData = data[0]?.recordData || [];
            let _homeTeamName = data[0].homeTeamName;
            let _awayTeamName = data[0].awayTeamName;

            const updatedGraphData = [...dataList];

            let this_record_data = _normalizeRecordDataForTeamName(recordData, homeTeamName, awayTeamName);
            const homeStats = setRecodeDataToGraph(updatedGraphData, this_record_data, homeTeamName, 0);

            setDataList(updatedGraphData);

            // 팀 이름
            setHomeTeamName(_homeTeamName);
            setAwayTeamName(_awayTeamName);
            // 그래프 데이터
            setRecordData(_homeTableData);
            // n경기 n승 n 패
            setHomeRecordStats(homeStats);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => console.log(err));
  }

  const formatDate = (dateString) => {
    const regex = /^\d{2}-\d{2}-\d{2}$/;

    if (regex.test(dateString)) {
      // 이미 YY-MM-DD 형식이면 YY.MM.DD 형식으로 변환
      return dateString.replace(/-/g, ".");
    }

    const date = dayjs(dateString);
    return date.format("YY.MM.DD");
  };


  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }
  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    );
  }

  return (
      <div className="flex flex-col justify-start min-h-[calc(100vh-8rem)]">
        <div className="flex flex-row justify-between items-center px-3">
          <div className="flex flex-row items-center justify-center">
            <span className="text-xl font-bold mr-3">상대 전적 통계</span>
            <div className="flex flex-row justify-around items-center px-3 text-sm font-bold">
              <span className="text-white bg-rose-600 px-2 py-1 rounded-full">승</span>
              <span className="text-white bg-orange-400 px-2 py-1 rounded-full mx-2">무</span>
              <span className="text-white bg-blue-700 px-2 py-1 rounded-full">패</span>
            </div>
          </div>

          {/*<div className="relative">*/}
          {/*  <RiAlignJustify className="h-7 w-auto" onClick={() => setShowOptionButton(prevState => !prevState)}/>*/}
          {/*  {showOptionButton &&*/}
          {/*      <div className="absolute flex flex-col right-0 mt-1">*/}
          {/*        {buttonData.map((button) => {*/}
          {/*          return (*/}
          {/*              <button className="bg-gray-200 w-24 ring-2 ring-black py-1"*/}
          {/*                      onClick={() => {*/}
          {/*                        setOptionButtonValue(button.value);*/}
          {/*                        setShowOptionButton(false);*/}
          {/*                      }}*/}
          {/*              >*/}
          {/*                {button.name}*/}
          {/*              </button>*/}
          {/*          )*/}
          {/*        })}*/}
          {/*      </div>*/}
          {/*  }*/}
          {/*</div>*/}
        </div>

        {/* <- 원형그래프 -> */}
        {homeRecordStats.count > 0 &&
            <div className="flex flex-col justify-around">
              <div className="flex flex-row justify-center items-center lg:px-20">
                <ChartDoughnut dataList={dataList[0]}/>
              </div>

              <div className="border border-black py-1 text-center rounded-full shadow-md px-2 text-sm font-bold mx-3">
                <span className="text-red-600 mr-3">홈팀기준</span>
                <span>{homeRecordStats.count}경기 {homeRecordStats.win}승 {homeRecordStats.draw}무 {homeRecordStats.lose}패</span>
              </div>
            </div>
        }

        <div className="w-full px-3">
          <table className="w-full mt-5 text-sm">
            <tbody>
            {recordData.map((data, index) => {
              return (
                  <React.Fragment key={index}>
                    <tr className="text-center ring-1 ring-gray-300 rounded-lg shadow-lg">
                      <td className="rounded-l-lg bg-white">{formatDate(data.date)}</td>
                      <td className={neverLandUtils.classNames(data.homeTeam === homeTeamName ? "bg-red-600 text-white" : data.homeTeam === awayTeamName ? "bg-blue-600 text-white" : "bg-white")}>
                        {neverLandUtils.trimTeamName(data.homeTeam)}
                      </td>
                      <td className="bg-white px-2">
                        <span className={data.homeScore > data.awayScore ? 'text-red-600' : 'black'}>
                          {data.homeScore}
                        </span>
                        {" : "}
                        <span className={data.homeScore < data.awayScore ? 'text-red-600' : 'black'}>
                          {data.awayScore}
                        </span>
                      </td>
                      <td className={neverLandUtils.classNames(data.awayTeam === homeTeamName ? "bg-red-600 text-white" : data.awayTeam === awayTeamName ? "bg-blue-600 text-white" : "bg-white", "rounded-r-lg")}>
                        {neverLandUtils.trimTeamName(data.awayTeam)}
                      </td>
                    </tr>
                    <tr className="h-5"></tr>
                  </React.Fragment>
              )
            })
            }
            </tbody>
          </table>
        </div>
      </div>
  )
}
export default OpponentRecordeComponent;

